import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import Notifications from './components/notifications/configuration';
import VueSanitize from 'vue-sanitize';
import Vuelidate from 'vuelidate';
import { isLoggedIn, getServerSubdomain } from '@/services/Authentication';

Notifications();
Vue.use(VueSanitize);
Vue.use(Vuelidate);
Vue.config.productionTip = false;

if (isLoggedIn()) {
  store.dispatch('getTarif', getServerSubdomain()).then(resp => {
    createAppInstance();
  });
} else {
  createAppInstance();
}

function createAppInstance() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}
